import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const ROVO_CHAT_CLIENT_ID: ClientId = client('rovo-chat');
